import { FC, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { Layout, useJourney, useTranslation } from "modules";
import { Paths } from "router/routes/paths";
import { useAppDispatch } from "store";
import { closeModal } from "store/actions/modal";

const ExitRegistrationModal: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { exitJourney } = useJourney();

  const closeModalWrapper = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const handleConfirm = useCallback(() => {
    exitJourney();
    navigate(Paths.login, { state: { ignoreAction: true } });
    closeModalWrapper();
  }, [closeModalWrapper, exitJourney, navigate]);

  const ctaButtons = [
    {
      text: t("registration.exit.moda.cta.primary", "LOG IN TO MY ACCOUNT"),
      onClick: handleConfirm,
    },
    {
      text: t("registration.exit.moda.cta.secondary", "NEVERMIND"),
      subType: "text-dark",
      onClick: closeModalWrapper,
    },
  ];

  const content = {
    header: t("registration.exit.modal.title", "Just so you know..."),
    subheader: t(
      "registration.exit.modal.subtitle",
      "If you continue, everything you just entered will be replaced with the details in your existing account."
    ),
    onClose: closeModalWrapper,
    button: ctaButtons,
    icon: "BlobAlert",
  };

  return <Layout as="ModalLayout" content={content} />;
};

export default ExitRegistrationModal;
